module.exports = __webpack_public_path__ + "static/media/driver-front-preview.e9f95601.svg";